import { gql, useMutation } from "@apollo/client";
import { CrossIcon, Spinner, toaster } from "evergreen-ui";
import React, { useState } from "react";
import { FaRegFile } from "react-icons/fa";

interface IProps {
  img: any;
  refetch: any;
}

const DELETE_FILE = gql`
  mutation deleteFile($id: Int!) {
    delete_gallery_image_by_pk(id: $id) {
      id
      url
      name
      collection
      type
      created_at
      sequence
      __typename
    }
  }
`;

const UPDATE_FILE = gql`
  mutation updateFile($id: Int!, $sequence: Int!) {
    update_gallery_image_by_pk(
      pk_columns: { id: $id }
      _set: { sequence: $sequence }
    ) {
      id
      url
      name
      collection
      type
      created_at
      sequence
      __typename
    }
  }
`;
const GalleryBox: React.FC<IProps> = ({ img, refetch }) => {
  let type = img.type?.split("/")[0];

  const [sequence, setSequence] = useState(img.sequence);
  const [deleteImage, { loading: deleteLoading }] = useMutation(DELETE_FILE);
  const [updateSequence, { loading: updatingSequence }] = useMutation(
    UPDATE_FILE
  );
  const onDeleteImage = () => {
    deleteImage({
      variables: {
        id: img.id,
      },
    }).then(() => {
      toaster.success("File deleted!");
      refetch();
    });
  };

  const onUpdateSequence = () => {
    updateSequence({
      variables: {
        id: img.id,
        sequence,
      },
    }).then(() => {
      toaster.success("Sequence updated!");
    });
  };
  const checkColor = () => {
    switch (img.type?.split("/")[1]) {
      case "pdf":
        return "red";
      case "vnd.ms-excel":
        return "green";
      case "excel":
        return "green";
      case "csv":
        return "green";
      case "xcel":
        return "green";
      default:
        return "blue";
    }
  };
  return (
    <div className=" flex flex-col shadow-md rounded-sm overflow-hidden">
      <div className=" relative w-full">
        {deleteLoading && (
          <div className=" bg-white absolute w-full h-full bg-opacity-60 flex items-center justify-center">
            <Spinner />{" "}
          </div>
        )}
        <div
          onClick={onDeleteImage}
          className=" z-10 absolute top-0 right-0 mt-2 mr-2 bg-white rounded-full shadow-md p-2 cursor-pointer hover:shadow-lg"
        >
          <CrossIcon size={12} />
        </div>
        {type === "image" ? (
          <img
            onClick={() => {
              window.open(img.url);
            }}
            src={img.url}
            width="100%"
            height="auto"
            alt={img.name}
            className=" hover:opacity-60 cursor-pointer  object-cover  w-full h-auto max-h-28"
          />
        ) : (
          <div
            onClick={() => {
              window.open(img.url);
            }}
            className=" hover:opacity-60 cursor-pointer  relative w-full flex items-center justify-center flex-col p-3 h-28"
          >
            <FaRegFile size={48} />
            <div
              className={`absolute text-xs bg-${checkColor()}-400 px-1 rounded-sm mt-4 ml-4 text-white`}
            >
              {img.type?.split("/")[1]}
            </div>
          </div>
        )}
      </div>
      <div className=" w-full pt-2 flex flex-col">
        <p className=" font-semibold px-2">{img.name}</p>
        <form
          onSubmit={onUpdateSequence}
          className=" flex flex-row w-full pt-2"
        >
          <input
            value={sequence}
            onChange={(e) => {
              setSequence(e.target.value);
            }}
            type="number"
            className=" w-full p-2 bg-gray-50"
            placeholder="Sequence"
          />
          <button
            onClick={onUpdateSequence}
            disabled={updatingSequence}
            className={`bg-blue-${
              updatingSequence ? "200" : "500"
            } px-2 text-white`}
          >
            {updatingSequence ? "Loading" : "SAVE"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GalleryBox;
